module.exports = __webpack_public_path__ + "static/img/gpt64.8710506c.png";